// src/components/IconActionBar.js
import React from "react";
import "../styles/IconActionBar.css";

const IconActionBar = ({ items, onSelect }) => {
  return (
    <div className="icon-action-bar">
      {items.map((it) => (
        <button
          key={it.key}
          className="icon-action-btn"
          title={it.title}
          onClick={() => onSelect?.(it.key)}
          disabled={it.disabled}
        >
          <span className="icon">{it.icon}</span>
        </button>
      ))}
    </div>
  );
};

export default IconActionBar;
